import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface IPayment {
  paymentId: number;
  orderId: number;
  userId?: number | null;
  transactionId?: string;
  poNumber?: string | null;
  userName?: string;

  paymentStatus?: string;
  totalAmount?: number;
  currency?: string | null;
  paymentDate?: number[] | string;
  [key: string]: any;
}

type PaymentFilterParams = {
  page?: number;
  size?: number;
  [key: string]: any;
};

const filterPayments = (params: PaymentFilterParams = {}) => {
  const { page = 0, size = 10, ...rest } = params;
  return Axios.get<any>(ENDPOINTS.payments.filter, {
    params: { page, size, ...rest },
  });
};

const getPaymentsByOrder = (orderId: number | string) => {
  return Axios.get<any>(ENDPOINTS.payments.byOrder(orderId));
};

const PaymentService = { filterPayments, getPaymentsByOrder };

export default PaymentService;
